import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import SelectMultipleField from '../../../../../../FormControl/input/SelectMultipleField';
import FormLcElements from '../CurriculumData/FormLcElements';
import FormCurriculumElements from '../CurriculumData/FormCurriculumElements';
import { Divider, FormControlLabel, Switch } from '@mui/material';

const CurriculumInformation = ({
  form,
  error,
  onChange,
  classes = { data: [], loading: false },
  ul = { data: [], loading: false }
}) => {
  return (
    <div>
      <Box className='flex flex-col gap-4 bg-primary text-primary-foreground px-2 py-2 rounded-md'>
        <Typography variant='inherit' className='font-bold capitalize' color='primary-foreground'>
          Filter by curriculum information
        </Typography>
      </Box>
      <div className='px-2 py-2 text-primary'>
        You must select at least 3 elements of the curriculum for a quick search.
      </div>
      <div className='grid grid-cols-3 items-center gap-4 pr-4 pt-2'>
        <FormCurriculumElements
          form={form.curriculumElements}
          onChange={(key, name, value, el) => {
            onChange('curriculumElements', key, name, value);
            onChange('curriculumElementsClass', key, name, value);
          }}
        />
        <FormLcElements
          form={form.lcElements}
          onChange={(key, name, value) => onChange('lcElements', key, name, value)}
        />

        <div className='col-span-full flex bg-loading px-4 py-4 rounded-lg items-start justify-between border-l border-l-2 border-primary'>
          <div className=''>
            <Typography variant='inherit' className='font-bold capitalize' color='primary' component='p'>
              Current year active rubrics only
            </Typography>
            <Typography variant='inherit' color='primary' component='p'>
              Show only LC columns from developmental rubrics linked to a class in the current year. Toggle
              off to view all historical data
            </Typography>
          </div>
          <FormControlLabel
            name='isActived'
            control={
              <Switch
                color='primary'
                checked={form.isActived === 'yes'}
                onChange={(e) => onChange('isActived', 'isActived', 'isActived', e.target.checked)}
              />
            }
            labelPlacement='start'
          />
        </div>

        {/* <div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Classes
          </Typography>
        </div>
        <div className='col-span-2'>
          <SelectMultipleField
            name='classId'
            placeholder='Select Class'
            value={form.classId}
            onChange={(e) => onChange('classId', 'classId', 'classId', e.target.value)}
            options={classes.data.map((item) => ({
              label: item.code,
              value: item._id
            }))}
            loading={classes.loading}
            helperText={classes.error}
            error={!!classes.error}
          />
        </div>
        <div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Unit of Learning
          </Typography>
        </div>
        <div className='col-span-2'>
          <SelectMultipleField
            name='ulId'
            placeholder='Select Unit of Learning'
            value={form.ulId}
            onChange={(e) => onChange('ulId', 'ulId', 'ulId', e.target.value)}
            options={ul.data.map((item) => ({
              label: item.name,
              value: item._id
            }))}
            loading={ul.loading}
            helperText={classes.error}
            error={!!classes.error}
          />
        </div> */}
      </div>
    </div>
  );
};

export default CurriculumInformation;
